// tslint:disable

import * as Cookie from 'js-cookie';
import { each } from 'lodash';
import * as React from 'react';
import { Field, FormLib } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import { ToggleBoxComponent } from '../structurals/toggle-box.component';
import { InputField } from './input.field';
import { SelectField } from './select.field';

export class SeoMetadataField extends BaseField<any> {
    public field: Field = this.props.field;
    public subForm: FormLib;
    public state: any = {initalized: false, user: false};

    componentWillMount() {
        this.setState({
            user: JSON.parse(Cookie.get('user') as string),
        });



        this.field.registerField();

        this.subForm = new FormLib({
            properties: [
                {
                    property: 'metaTitle',
                    title: 'Title'
                },
                {
                    property: 'metaDescription',
                    title: 'Description'
                },
                {
                    property: 'metaKeywords',
                    title: 'Keywords'
                },
                {
                    property: 'ogTitle',
                    title: 'Title'
                },
                {
                    property: 'ogDescription',
                    title: 'Description'
                },
                {
                    property: 'ogLocale',
                    title: 'Locale'
                },
                {
                    property: 'ogType',
                    title: 'Type'
                },
                {
                    property: 'ogAuthor',
                    title: 'Author'
                },
                {
                    property: 'ogPublisher',
                    title: 'Publisher'
                },
                {
                    property: 'ogImage',
                    title: 'Image'
                },
                {
                    property: 'robots',
                    title: 'Robots'
                },
            ]
        });

        this.field.onValueChanges$.subscribe((value: any) => {
            each(value, (v: any, k: string) => {
                if (this.subForm.fields[k]) {
                    this.subForm.fields[k].setValue(v, true, true);
                }
            });
            this.setState({initalized: true});
        });

        this.subForm.onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$.subscribe((value: any) => {
            this.field.setValue(this.subForm.toJS(), false, false);
        });
    }

    render() {
        if (this.state.initalized) {
            return (
                <div>
                    <ToggleBoxComponent title="SEO Meta tags" color="blue" alwaysOpen={true} preIcon="fa-sitemap">

                        <ul className="nav nav-tabs">
                            <li className="nav-item"><a href="#tab1" data-toggle="tab" className="nav-link active">Google</a></li>
                            <li className="nav-item"><a href="#tab2" data-toggle="tab" className="nav-link">Facebook</a></li>
                            <li className="nav-item"><a href="#tab3" data-toggle="tab" className="nav-link">Linkedin</a></li>
                            <li className="nav-item"><a href="#tab4" data-toggle="tab" className="nav-link">Twitter</a></li>
                        </ul>
                        <div className="tab-content">
                            <div className="tab-pane fade in active" id="tab1">

                                {this.subForm.fields.metaTitle &&
                                <InputField
                                    field={this.subForm.fields.metaTitle}
                                />
                                }
                                {this.subForm.fields.metaKeywords &&
                                <InputField
                                    field={this.subForm.fields.metaKeywords}
                                />
                                }
                                {this.subForm.fields.metaDescription &&
                                <InputField
                                    field={this.subForm.fields.metaDescription}
                                />
                                }

                                {this.subForm.fields.robots &&
                                <SelectField
                                    field={this.subForm.fields.robots}
                                    options={[
                                        {label: 'INDEX, FOLLOW', value:'INDEX, FOLLOW'},
                                        {label: 'INDEX, NOFOLLOW', value:'INDEX, NOFOLLOW'},
                                        {label: 'NOINDEX, FOLLOW', value:'NOINDEX, FOLLOW'},
                                        {label: 'NOINDEX, NOFOLLOW', value:'NOINDEX, NOFOLLOW'}
                                    ]}
                                    decode={(value: any) => SelectField.StringDecoder(value)}
                                    encode={(value: any) => SelectField.StringEncoder(value)}
                                />
                                }
                            </div>
                            <div className="tab-pane fade" id="tab2">
                                {this.subForm.fields.ogTitle &&
                                <InputField
                                    field={this.subForm.fields.ogTitle}
                                />
                                }
                                {this.subForm.fields.ogDescription &&
                                <InputField
                                    field={this.subForm.fields.ogDescription}
                                />
                                }
                                {this.subForm.fields.ogLocale &&
                                <InputField
                                    field={this.subForm.fields.ogLocale}
                                />
                                }
                                {this.subForm.fields.ogType &&
                                <InputField
                                    field={this.subForm.fields.ogType}
                                />
                                }
                                {this.subForm.fields.ogAuthor &&
                                <InputField
                                    defaultValue={this.state.user.facebookId}
                                    field={this.subForm.fields.ogAuthor}
                                    helpText="Facebook User ID"
                                />
                                }
                                {this.subForm.fields.ogPublisher &&
                                <InputField
                                    field={this.subForm.fields.ogPublisher}
                                    helpText="Facebook Page ID"
                                />
                                }
                            </div>
                            <div className="tab-pane fade" id="tab3">
                                <p><b>Linkedin</b><br/>Coming soon.</p>
                            </div>
                            <div className="tab-pane fade" id="tab4">
                                <p><b>Twitter</b><br/>Coming soon.</p>
                            </div>
                        </div>
                    </ToggleBoxComponent>
                </div>

            );
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/seoMetadata.field.tsx